export const TIME_OUT_MILLISECONDS = 5000;
